import * as Common from '@/tenant/common';

export class BankAccount extends Common.MasterBase{
  constructor(){
    super('BankAccount');
    this.binders.account = new Common.ModelBinder(Common.Account);
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public code: string = null;
  public bankName: string = null;
  public bankBranchName: string = null;
  public currencyCode: string = null;
  public bankAccountCategory: BankAccountCategoryTypes = BankAccountCategoryTypes.Saving;
  public bankAccountCode: string = null;
  public bankAccountName: string = null;  
  public name: string = null;
  public segmentId: number = null;
  public segment: Common.Segment = null;
  public accountCode: string = null;
  public account: Common.Account = null;
  public subAccountCode: string = null;
  public taxSystemCurrencyFee: string = null;
  public mappingCodeBS: string = '';  
  public mappingCodePL: string = '';    
  // public taxOtherCurrencyFee: string = null;
  
  // 振込連携設定（旧：全銀設定）
  public useFirmBanking: boolean = false;
  public nameKana: string = null;
  public bankCode: string = null;
  public bankNameKana: string = null;
  public bankBranchCode: string = null;
  public bankBranchNameKana: string = null;
  public companyRefCode: string = null;
  public companyRefName: string = null;

  // 貿易書類設定
  public bankNameInv: string = null;
  public swiftCode: string = null;
  public bankBranchNameInv: string = null;
  public bankAccountCodeInv: string = null;
  public bankAccountNameInv: string = null;

  public copy():any {
    const temp = super.copy() as BankAccount;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export enum BankAccountCategoryTypes
{
    Default = 0, //
    Saving = 1, // 普通
    Checking = 2, // 当座
    Deposit = 3, // 貯蓄
    Other = 4 // その他
}

export class BankAccountQuery extends Common.LoadQuery {
  constructor(){
    super('BankAccountQuery',BankAccount);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';  
  public bankName: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class BankAccountMasterQuery extends Common.LoadQuery {
  constructor(){
    super('BankAccountMasterQuery', BankAccount);
  }
}

export class BankAccountImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super("",null);
    this.className = "BankAccountImportQuery";
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
    this.hasLicenseTrade = false;
  }
  public sheetName: string;
  public hasLicenseCurrency: boolean;
  public hasLicenseTrade: boolean;
}

export class BankAccountExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "BankAccountExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.hasLicenseCurrency = false;
    this.hasLicenseTrade = false;
  }
  public loadQuery: Common.LoadQuery;
  public sheetName: string;
  public hasLicenseCurrency: boolean;
  public hasLicenseTrade: boolean;
}

export class GetCusotmerBankAccountQuery extends Common.Query {
  constructor(){
    super('GetCusotmerBankAccountQuery',new Common.ModelBinder(Common.BankAccount,false));
  }

  public customerList: Array<Common.Counterpart> = null;
}